// extracted by mini-css-extract-plugin
export var inline = "_to-0";